export default __webpack_public_path__ + "static/media/mail.a7ae0da3.svg";